<template>
  <div class="pages" v-loading="listLoading">
    <div
      v-for="(item, index) in templateData.TemplateContent.Controls"
      :key="index"
    >
      <Digit v-if="item.Property.Control === 'Number'" :data-val="item"></Digit>
      <Contact
        v-if="item.Property.Control === 'Condition'"
        :data-val="item"
      ></Contact>
      <DateTimes
        v-if="item.Property.Control === 'Date'"
        :data-val="item"
      ></DateTimes>
      <Version
        v-if="item.Property.Control === 'Text'"
        @child-event="getTextVal"
        :data-val="item"
      ></Version>
      <Money v-if="item.Property.Control === 'Money'" :data-val="item"></Money>
      <Tips v-if="item.Property.Control === 'Tips'" :data-val="item"></Tips>
      <File v-if="item.Property.Control === 'File'" :data-val="item"></File>
      <Table
        v-if="item.Property.Control === 'Table'"
        @child-event="tableOperation"
        :data-val="item"
      ></Table>
      <Selector
        v-if="item.Property.Control === 'Selector'"
        @child-event="getSelectorVal"
        :data-val="item"
      ></Selector>
      <Textarea
        v-if="item.Property.Control === 'Textarea'"
        :data-val="item"
      ></Textarea>
      <Choose
        v-if="item.Property.Control === 'Contact'"
        @child-event="clickChoose"
        :data-val="item"
      ></Choose>
    </div>
    <Button
      class="submit-process"
      v-on:click="submit"
      v-bind:disabled="isDisabled"
      v-bind:loading="formLoading"
      size="large"
      type="primary"
    >
      提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import DateTimes from "../components/DateTime.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";
import { initWxConfig } from "../api/jssdk.js";
import { getTemplateInfo, submitProcess } from "@/api/approval";
import { getDepartmentInfo } from "@/api/department";
import { getRelation, getAgentInfo } from "@/api/employee";
import DateTime from "@/components/DateTime";
import {
  saveVehicleInformation,
  getVehicleInformationByTime,
} from "@/api/vehicle";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    DateTimes,
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
    };
  },
  created() {
    initWxConfig(this);
    this.logInfo = this.getLoginUserInfo();
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(true);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      if (
        dataVal.Property.Title[0].Text === "用车人" ||
        dataVal.Property.Title[0].Text === "司机"
      ) {
        window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              // 已选的部门列表
              var user = res.result.userList[0];
              dataVal.Values = [];
              dataVal.Values.push([user.id, user.name]);
              dataVal.Value = user.name;
            }
          }
        );
      } else {
        window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              // 已选的部门列表
              var depart = res.result.departmentList[0];
              dataVal.Values = [];
              dataVal.Values.push([depart.id, depart.name]);
              dataVal.Value = depart.name;
            }
          }
        );
      }
    },
    getEmployeeRelation: async function (empNo) {
      await getRelation(empNo).then((response) => {
        this.relationList = response.Body[0].Nodes;
      });
    },
    getTextVal() {},
    getSelectorVal(val, name) {
      // if (name === "车牌号几座") {
      //   let options = [];
      //   let value = "";
      //   let controls = this.templateData.TemplateContent.Controls;
      //   for (let i = 0; i < controls.length; i++) {
      //     let con = controls[i];
      //     if (con.Property.Title[0].Text === "车牌号几座") {
      //       options = con.Config.Selector.Options;
      //     }
      //   }
      //   for (let i = 0; i < options.length; i++) {
      //     let option = options[i];
      //     if (option.Key === val) {
      //       value = option.Value[0].Text;
      //     }
      //   }
      //   value = value.replace(/\s*/g, "");
      //   if (value === "川A42k99 5座".replace(/\s*/g, "")) {
      //     controls.forEach((control) => {
      //       if (control.Property.Placeholder[0].Text.indexOf("限行说明") > -1) {
      //         control.Property.Placeholder[0].Text =
      //           "限行说明：川A42k99限行周四; 周二只能申请42K99";
      //           //"限行说明：川A42k99 ";
      //       }
      //     });
      //   } else if (value === "川A90zy2   7座".replace(/\s*/g, "")) {
      //     controls.forEach((control) => {
      //       if (control.Property.Placeholder[0].Text.indexOf("限行说明") > -1) {
      //         control.Property.Placeholder[0].Text =
      //           "限行说明：川A90zy2限行周二; 周一、周三、周四、周五，只能申请90ZY2";
      //       }
      //     });
      //   }
      // }
    },
    tableOperation: async function (val, type, datas) {
      this.tableoperation(val, type, datas, this);
    },
    getTemplate: async function () {
      var that = this;
      that.listLoading = true;
      var title = that.logInfo.fullName;
      var jobLevel = that.logInfo.JobLevel;
      await that.getEmployeeRelation(that.logInfo.EmpNo);
      getTemplateInfo(this.templateId).then(async (response) => {
        var controls = response.Body;
        for (const item of controls.TemplateContent.Controls) {
          if (item.Property.Title[0].Text === "流程编号") {
            item.IsShow = false;
          }
          if (item.Property.Title[0].Text === "司机") {
            item.IsShow = false;
          }

          if (item.Property.Title[0].Text === "起始时间") {
            item.Property.Control = "Date";
          }
          if (item.Property.Title[0].Text === "结束时间") {
            item.Property.Control = "Date";
          }
          if (item.Property.Title[0].Text === "车牌号几座") {
            let options = item.Config.Selector.Options;
            let key = options[0].Key;
            item.Value = key;
          }
          this.templateData = this.assignControl(controls, this.logInfo);
          this.templateData = await this.assignControlBySpNo(
            controls,
            this.spNo
          );
          this.listLoading = false;
        }
      });
    },
    SaveVehicle: async function () {
      let vehicleInformation = {
        //车牌号(几座)
        LicensePlate: "",
        //限行说明
        TravelRestrictions: "",
        //开始时间
        StartTime: "",
        // 结束时间
        EndTime: "",
        //出发地-目的地
        Trip: "",
        //事由
        SubjectMatter: "",
        //用车人
        VehicleOwner: "",
        //用车部门
        VehicleDepartment: "",
      };

      vehicleInformation = await this.PageDataToVehicleInformation(
        vehicleInformation
      );
      await saveVehicleInformation(vehicleInformation).then((res) => {
        console.log(res);
      });
    },
    getDataV() {
      let vehicleInformation = {
        //车牌号(几座)
        LicensePlate: "",
        //限行说明
        TravelRestrictions: "",
        //开始时间
        StartTime: "",
        // 结束时间
        EndTime: "",
        //出发地-目的地
        Trip: "",
        //事由
        SubjectMatter: "",
        //用车人
        VehicleOwner: "",
        //用车部门
        VehicleDepartment: "",
      };
      return this.PageDataToVehicleInformation(vehicleInformation);
    },
    PageDataToVehicleInformation(vehicleInformation) {
      this.templateData.TemplateContent.Controls.forEach((control) => {
        if (control.Property.Title[0].Text === "车牌号几座") {
          vehicleInformation.LicensePlate = this.KeyFindValue(
            control.Value,
            control
          );
        }
        if (control.Property.Title[0].Text === "起始时间") {
          vehicleInformation.StartTime = control.Value;
        }
        if (control.Property.Title[0].Text === "结束时间") {
          vehicleInformation.EndTime = control.Value;
        }
        if (control.Property.Title[0].Text === "用车人") {
          vehicleInformation.VehicleOwner = control.Value;
        }
        if (control.Property.Title[0].Text === "用车部门") {
          vehicleInformation.VehicleDepartment = control.Value;
        }
        if (control.Property.Title[0].Text === "出发地-目的地") {
          vehicleInformation.Trip = control.Value;
        }
        if (control.Property.Title[0].Text === "事由") {
          vehicleInformation.SubjectMatter = control.Value;
        }
        if (control.Property.Placeholder[0].Text.indexOf("限行说明") > -1) {
          vehicleInformation.TravelRestrictions =
            control.Property.Placeholder[0].Text;
        }
      });
      return vehicleInformation;
    },
    getWeeksFromDate(startDate, endDate) {
      let beginDateObj = new Date(startDate);
      let endDateObj = new Date(endDate);
      let weeksArr = [];
      while (beginDateObj <= endDateObj) {//直到结束日期，跳出循环
        if (weeksArr.indexOf(beginDateObj.getDay()) === -1) {//数组中不存在，则push到数组中
          let weekNum = beginDateObj.getDay();
          if (weekNum == 0) {//如果为0，则对应“周日”
            weekNum = 7;
          }
          weeksArr.push(weekNum);
        }
        beginDateObj.setTime(beginDateObj.getTime() + 24 * 60 * 60 * 1000);//每次递增1天
      }
      return weeksArr;
    },
    KeyFindValue(Key, control) {
      let options = control.Config.Selector.Options;
      for (let i = 0; i < options.length; i++) {
        let option = options[i];
        if (option.Key === Key) {
          return option.Value[0].Text;
        }
      }
    },
    submit: async function () {
      var controls = this.templateData.TemplateContent.Controls;
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }

      var dataResult = this.getDataV();

      var WeekArr = this.getWeeksFromDate(dataResult.StartTime,dataResult.EndTime);
      var WeekChecked = false;
      //验证是否限号
      // controls.forEach((control) => {
      //   if (control.Property.Placeholder[0].Text.indexOf("限行说明") > -1) {
      //     if (control.Property.Placeholder[0].Text.indexOf("A90zy2") > -1){
      //       if(WeekArr.indexOf(2) > -1 || WeekArr.indexOf(6) > -1 || WeekArr.indexOf(7) > -1){
      //         WeekChecked = true;
      //       }
      //     }else if(control.Property.Placeholder[0].Text.indexOf("A42k99") > -1){
      //       if(WeekArr.filter(e => e != 2).length > 0){
      //         WeekChecked = true;
      //       }
      //     }
      //   }
      // });
      /**
       * controls.forEach((control) => {
        if (control.Property.Placeholder[0].Text.indexOf("限行说明") > -1) {
          if (control.Property.Placeholder[0].Text.indexOf("周四") > -1){
            if(WeekArr.indexOf(4) > -1){
              WeekChecked = true;
            }
          }else if(control.Property.Placeholder[0].Text.indexOf("周二") > -1){
            if(WeekArr.indexOf(2) > -1){
              WeekChecked = true;
            }
          }
        }
      });
       * 
       */
      // if (WeekChecked) {
      //   this.Message({
      //     message: "时间段中含有车辆限号",
      //     type: "error",
      //     duration: 3 * 1000,
      //   });
      //   return;
      // }
      let check = false;
      let body = null
      //验证时间段
      await getVehicleInformationByTime(
        dataResult.LicensePlate,
        dataResult.StartTime,
        dataResult.EndTime
      ).then((res) => {
        body = res.Body
        check = res.Body === null;
      });
      if (!check) {
        for (const item of body) {
          setTimeout(() => {
            this.Message({
              message: `该时段已有申请，${item.StartTime}-${item.EndTime}，${item.VehicleOwner}，请知晓~`,
              type: "error",
              duration: 3 * 1000
            })
          },200)
        }
        return;
      }
      var SummaryList = [];
      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      var control1 = this.templateData.TemplateContent.Controls.filter((t) => {
        return t.Property.Title[0].Text === "人员";
      })[0];
      var control3 = this.templateData.TemplateContent.Controls.filter((t) => {
        return t.Property.Title[0].Text === "部门";
      })[0];
      var control4 = this.templateData.TemplateContent.Controls.filter((t) => {
        return t.Property.Title[0].Text === "用车人";
      })[0];
      var control5 = this.templateData.TemplateContent.Controls.filter((t) => {
        return t.Property.Title[0].Text === "用车部门";
      })[0];
      var control6 = this.templateData.TemplateContent.Controls.filter((t) => {
        return t.Property.Title[0].Text === "起始时间";
      })[0];
      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text:
          "申请人信息：" +
          " " +
          control1.Value +
          "  " +
          this.logInfo.EmpNo +
          "  " +
          control3.Value,
        Lang: "zh_CN",
      });
      SummaryList.push(info);
      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text:
          "用车人姓名：" +
          " " +
          control4.Value +
          "  " +
          "用车部门: " +
          control5.Value,
        Lang: "zh_CN",
      });
      SummaryList.push(info);
      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text: "出发时间：" + control6.Value,
        Lang: "zh_CN",
      });
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList;
      isSubmit = true;
      this.listLoading = true;

      this.templateData.TemplateContent.Controls.forEach((item) => {
        if (item.Property.Title[0].Text === "司机") {
          item.IsShow = true;
        }
        if (item.Property.Title[0].Text === "起始时间") {
          item.Property.Control = "Text";
        }
        if (item.Property.Title[0].Text === "结束时间") {
          item.Property.Control = "Text";
        }
      });
      // let a = true;
      // if (a){ return}
      //提交
      submitProcess(
        this.templateId,
        this.logInfo.EmpNo,
        this.spNo,
        this.templateData
      )
        .then((response) => {
          if (response.Body.ErrCode !== 0) {
            this.templateData.TemplateContent.Controls.forEach((item) => {
              if (item.Property.Title[0].Text === "司机") {
                item.IsShow = false;
              }
              if (item.Property.Title[0].Text === "起始时间") {
                item.Property.Control = "Date";
              }
              if (item.Property.Title[0].Text === "结束时间") {
                item.Property.Control = "Date";
              }
            });
            this.Message({
              message: "申请失败，请稍后重试",
              type: "error",
              duration: 3 * 1000,
            });
          }else{
            console.log("Success");
            //数据存储
            this.SaveVehicle();
            this.Message({
              message: "申请成功",
              type: "success",
              duration: 3 * 1000,
            });
            setTimeout(() => {
              this.$router.push("/index");
            }, 3000);
          }
          })
        .finally(() => {
          isSubmit = false;
          this.listLoading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>